import { render, staticRenderFns } from "./PrivacyPolicyHeader.vue?vue&type=template&id=67aff820&scoped=true"
var script = {}
import style0 from "./PrivacyPolicyHeader.vue?vue&type=style&index=0&id=67aff820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aff820",
  null
  
)

export default component.exports